export default __webpack_public_path__ + "static/media/review2.8f9855b0.jpg";